<template>
    <div>
        <Hero />

        <div class="p-8 md:p-20">
            <div class="uppercase font-bold text-xl">About</div>
            <div class="text-xl mt-3 flex flex-col gap-y-4">
                <p>Our school outreach scheme seeks to reach out to children within their educational environments. We understand that we can shape the lives of children by exposing them to the truth of God's word at a very young age.</p>
                <p>In our school outreach, we visit several schools where we preach the gospel and also teach children systematically to help build them up on their knowledge of Christ.</p>
                <p>The aim is to raise people who value salvation and its implications and are committed to the gospel and the study of God's word.</p>
            </div>

            <div class="grid md:grid-cols-2 mt-5 gap-3">
                <div>
                    <img src="../assets/images/school_outreach_1.jpg" alt="" class="w-full rounded">
                </div>
                <div>
                    <img src="../assets/images/school_outreach_2.jpg" alt="" class="w-full rounded">
                </div>
            </div>

            <RouterLink to="/give" class="mt-10 flex justify-center">
                <SecondaryButton content="support the work" />
            </RouterLink>
        </div>

        <BecomeOurFamily/>

        <BottomLinks />
    </div>
</template>

<script setup>
import Hero from '../components/School_Outreach/Hero.vue';
import SecondaryButton from '../components/SecondaryButton.vue'
import BecomeOurFamily from '../components/BecomeOurFamily.vue';
import BottomLinks from '../components/School_Outreach/BottomLinks.vue';
</script>

<style scoped>

</style>